export const GET_ALL_PAUSAS = 'GET_ALL_PAUSAS'
export const GET_SPECIFIC_PAUSA = 'GET_SPECIFIC_PAUSA'
